import { web3Util } from '../utils/web3Util';
import { tx } from './tx';

export default function approveForAll(operator: string) {
  const contract = web3Util.getContract('heroes');
  return tx(contract.methods.setApprovalForAll(operator, true));
}
